export const GET_CUSTOM_INTG_ADMIN_REQUEST = 'GET_CUSTOM_INTG_ADMIN_REQUEST';
export const GET_CUSTOM_INTG_ADMIN_SUCCESS = 'GET_CUSTOM_INTG_ADMIN_SUCCESS';
export const GET_CUSTOM_INTG_ADMIN_FAILURE = 'GET_CUSTOM_INTG_ADMIN_FAILURE';
